<template>
	<!-- 客户详情 -->
	<div class="wechat-wrap">
		<van-dialog v-model="show" title="微信昵称复制成功" cancelButtonText='我知道了' :showCancelButton='true'
			:showConfirmButton='false' cancelButtonColor='#515A6E'>
			<p class="notice">您可以打开微信搜索用户</p>
		</van-dialog>
	</div>
</template>

<script>
	var timer;
	import {
		loading,
		common
	} from "@/api/mixins";
	import Clipboard from 'clipboard';
	export default {
		data() {
			return {
				show: false,
				phone: ''
			};
		},
		mixins: [loading, common],
		props: ['customerId', 'customerInfo'],
		computed: {},
		methods: {
			open() {
				this.show = true;
			},
		},
		mounted() {}
	};
</script>

<style lang="scss" scoped>
	.wechat-wrap {
		/deep/.van-dialog__header{
			font-size: 34px;
			font-weight: 600;
			line-height: 48px;
			color: #17233D;
			padding-top: 42px;
		}
		/deep/.van-dialog__cancel{
			width: 670px;
			height: 90px;
			background: rgba(247,247,247,0.39);
			opacity: 1;
			border-radius: 0px 0px 20px 20px;
			
			font-size: 30px;
			color: #515A6E;
		}
		.notice {
			font-size: 30px;
			line-height: 42px;
			color: #17233D;
			text-align: center;
			padding: 10px 0 38px;
		}
	}
</style>
